import { SearchPoolInput } from "../SearchPoolInput/SearchPoolInput";

type Props = {
  searchValue: string;
  setSearchValue: (value: string) => void;
};

export const TableControlls: React.FC<Props> = ({
  searchValue,
  setSearchValue,
}) => {
  return (
    <div className="flex items-center justify-between">
      <SearchPoolInput
        searchValue={searchValue}
        setSearchValue={setSearchValue}
      />
    </div>
  );
};
